import PropTypes from 'prop-types';
import { pageContext, replaceBaseUrl } from 'ctm-util-functions';

/**
 * Returns the asset file path on runtime
 * @param {string} relativePath e.g. /assets/brand/ctm/images/alexander_half_with_bg.png from build folder
 * @returns {string} runtime asset source path
 */
const getAssetFilePath = (relativePath) => {
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    return replaceBaseUrl(`/evt${relativePath}`, baseAssetsPath);
};

getAssetFilePath.propTypes = {
    relativePath: PropTypes.string.isRequired
};

export { getAssetFilePath };
